import _find from 'lodash/find';
import { formatCurrency } from '../../../utils/currency';
import { isPriceLabel } from '../../../utils/currency/currency';
export function getCategoryItems(category, allItems) {
  var items = category.items;
  return items.map(function (itemId) {
    return _find(allItems, function (_ref) {
      var _id = _ref._id;
      return _id === itemId;
    });
  });
}
export function getPriceDisplay(price) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref2$displayZeroCost = _ref2.displayZeroCost,
    displayZeroCost = _ref2$displayZeroCost === void 0 ? false : _ref2$displayZeroCost,
    _ref2$precision = _ref2.precision,
    precision = _ref2$precision === void 0 ? 2 : _ref2$precision;
  if (isPriceLabel(price)) {
    return price;
  }
  var parsedPriced = +price;
  if (parsedPriced === 0 && !displayZeroCost) {
    return '';
  }
  return formatCurrency(parsedPriced, precision);
}